<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";

export default {
  name: "PopinConfirmationMagasin",
  components: {
    Popin,
    Icon,
    Button
  },
  props: {
    currentMagasinName: {
      type: String,
      required: false,
      default: ""
    },
    newMagasinName: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: ["cancelled", "changeMagasin"],
  methods: {
    show() {
      this.$refs.popin.show();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    size="lg"
    aria-label="Changement de magasin"
    :show-close-button="false"
    :back-drop-close="false"
  >
    <div class="u-text-center u-font-15">
      <div class="c-popin-confirmation-magasin__title u-mb-sm">
        <Icon
          name="shop"
          size="xxlg"
        />
        <Icon
          name="alert-circle"
          variant="primary"
          size="sm"
          class="c-popin-confirmation-magasin__title-icon"
        />
      </div>
      <h2>
        Bienvenue sur le magasin <span class="u-color-primary">{{ newMagasinName }}</span> !
      </h2>
      <h3 class="u-mt-md u-mb-md">
        Vous étiez précédemment rattaché(e) au magasin de <span class="u-color-primary">{{ currentMagasinName }}</span>
      </h3>
      <p>
        Si vous avez un panier en cours dans votre magasin actuel, celui-ci sera conservé 3 jours.
        <br>
        En validant le changement de magasin, vous consulterez les offres disponibles dans ce magasin.
      </p>
      <div class="u-inline-flex u-mt-md u-flex-column-reverse@md">
        <Button
          variant="primary"
          outline
          radius="full"
          size="md"
          class="u-mr-sm u-mr-none@md"
          @click="$emit('cancelled')"
        >
          Je préfère revenir au magasin de
          <br>
          {{ currentMagasinName }}
        </Button>
        <Button
          variant="primary"
          radius="full"
          size="md"
          class="u-ml-md u-ml-none@md u-mb-sm@md"
          @click="$emit('changeMagasin')"
        >
          Ok, je continue dans ce magasin
        </Button>
      </div>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
.c-popin-confirmation-magasin__title {
  position: relative;
  display: inline-block;
}
.c-popin-confirmation-magasin__title-icon {
  position: absolute;
  bottom: 2px;
  right: 0px;
  background-color: #fff;
  border-radius: 100%;
}
</style>
